export default {
    meta: {
        title: '拓店宝-关联机会点'
    },
};
